import styled from 'styled-components';
import FrizSvg from '../../assets/amenities/friz.svg';

const FrizIcon = styled(FrizSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default FrizIcon;
